export default "__VITE_ASSET__HZ8qkXPJ__"